import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { qualSpec } from '../internal/variants.js';
export function QualState({ state }) {
    const m = qualSpec(state);
    return (_jsxs("span", { className: 'state ' + m.cls, children: [_jsx("span", { className: "dot" }), m.label] }));
}
//# sourceMappingURL=QualState.js.map